import breakfastHot from './images/breakfast/hot-breakfast.jpg'
import breakfastCold from './images/breakfast/cold-breakfast.webp'
import breakfastBoth from './images/breakfast/both-breakfast.jpg'
import afternoonTeaSweet from './images/afternoon-tea/sweet.webp'
import afternoonTeaSavoury from './images/afternoon-tea/savoury.jpg'
import afternoonTeaBoth from './images/afternoon-tea/both.webp'
import lunchClassic from './images/lunch/classic.webp'
import lunchSpecialty from './images/lunch/specialty.webp'
import lunchBoth from './images/lunch/both.webp'
import sweetTreatsCakes from './images/sweet-treats/cakes.webp'
import sweetTreatsNibbles from './images/sweet-treats/nibbles.jpg'
import sweetTreatsBoth from './images/sweet-treats/other.webp'
import deliveredImage from './images/delivered-popup/delivered.webp'
import popupImage from './images/delivered-popup/popup.webp'
import {
  eventDetailsServingType as commonEventDetailsServingType,
  occasionRequirements,
  occasionEventStyle,
  occasionServiceStyle,
  occasionOnsiteFacilities,
  occasionFoodServiceTime,
  occasionStaffServiceTime,
} from '../common'
import { EventDetailsType, OccasionFieldsAndEventDetails, TextType } from '../types'
import { match } from 'ts-pattern'

// Image Cards

const occasionBreakfastType: EventDetailsType = {
  id: 'subtype',
  label: 'emma:breakfast_question',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'emma:breakfast_types_hot',
      label: undefined,
      value: 'HOT',
      image: breakfastHot,
    },
    {
      title: 'emma:breakfast_types_cold',
      label: undefined,
      value: 'COLD',
      image: breakfastCold,
    },
    {
      title: 'emma:breakfast_types_both',
      label: undefined,
      value: 'BOTH',
      image: breakfastBoth,
    },
  ],
}

const occasionMorningTeaType: EventDetailsType = {
  id: 'subtype',
  label: 'What ratio of sweet/savoury would you like?',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'More sweet',
      label: undefined,
      value: 'SWEET',
      image: afternoonTeaSweet,
    },
    {
      title: 'More savoury',
      label: undefined,
      value: 'SAVOURY',
      image: afternoonTeaSavoury,
    },
    {
      title: 'Recommended - 50/50',
      label: undefined,
      value: 'BOTH',
      image: afternoonTeaBoth,
    },
  ],
}

const occasionAfternoonTeaType: EventDetailsType = {
  id: 'subtype',
  label: 'What ratio of sweet/savoury would you like?',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'More sweet',
      label: undefined,
      value: 'SWEET',
      image: afternoonTeaSweet,
    },
    {
      title: 'More savoury',
      label: undefined,
      value: 'SAVOURY',
      image: afternoonTeaSavoury,
    },
    {
      title: 'Recommended - 50/50',
      label: undefined,
      value: 'BOTH',
      image: afternoonTeaBoth,
    },
  ],
}

const occasionLunchType: EventDetailsType = {
  id: 'subtype',
  label: 'What kind of lunch are you looking for?',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'Classic Office Catering',
      label: 'salads, sandwiches, finger food etc',
      value: 'CLASSIC',
      image: lunchClassic,
    },
    {
      title: 'Specialty Cuisine',
      label: 'unique cuisine options, e.g. Indian, Thai, Mexican',
      value: 'SPECIALTY',
      image: lunchSpecialty,
    },
    {
      title: 'Not Sure',
      label: "we'll provide a few classic & specialty options",
      value: 'BOTH',
      image: lunchBoth,
    },
  ],
}

const occasionDinnerType: EventDetailsType = {
  id: 'subtype',
  label: 'What kind of dinner are you looking for?',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'Classic Office Catering',
      label: 'salads, sandwiches, finger food etc',
      value: 'CLASSIC',
      image: lunchClassic,
    },
    {
      title: 'Specialty Cuisine',
      label: 'unique cuisine options, e.g. Indian, Thai, Mexican',
      value: 'SPECIALTY',
      image: lunchSpecialty,
    },
    {
      title: 'Not Sure',
      label: "we'll provide a few classic & specialty options",
      value: 'BOTH',
      image: lunchBoth,
    },
  ],
}

const occasionSweetTreatsType: EventDetailsType = {
  id: 'subtype',
  label: 'What kind of sweet treats are you looking for?',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'Cakes',
      label: undefined,
      value: 'CAKES',
      image: sweetTreatsCakes,
    },
    {
      title: 'Sweet Nibbles',
      label: undefined,
      value: 'NIBBLES',
      image: sweetTreatsNibbles,
    },
    {
      title: 'Both',
      label: undefined,
      value: 'BOTH',
      image: sweetTreatsBoth,
    },
  ],
}

const occasionLunarNewyearType: EventDetailsType = {
  id: 'subtype',
  label: 'Would you like to have it delivered or a popup?',
  type: 'image-cards',
  needs: [],
  prefill: true,
  options: [
    {
      title: 'Delivered',
      label: undefined,
      value: 'DELIVERED',
      image: deliveredImage,
    },
    {
      title: 'Popup',
      label: undefined,
      value: 'POPUP',
      image: popupImage,
    },
  ],
}

const occasionHarmonyType: EventDetailsType = {
  ...occasionLunarNewyearType,
  id: 'subtype',
}

// Text Fields

const occasionEventOtherSimple: TextType = {
  id: 'eventTypeOtherSimple',
  placeholder: 'Example: Corporate Function / Event',
  label: 'What is the occasion?',
  inputLabel: 'Occasion',
  type: 'text',
  needs: [],
  prefill: false,
}

const occasionInternationalWomensDayType: EventDetailsType = {
  ...occasionAfternoonTeaType,
  id: 'internationalWomensDayType',
}
const occasionEasterType: EventDetailsType = { ...occasionAfternoonTeaType, id: 'easterType' }
const occasionMardiGrasType: EventDetailsType = { ...occasionAfternoonTeaType, id: 'mardiGrasType' }
const occasionAustraliasBiggestMorningTeaType: EventDetailsType = {
  ...occasionAfternoonTeaType,
  id: 'australiasBiggestMorningTeaType',
}
const occasionReconciliationType: EventDetailsType = {
  ...occasionAfternoonTeaType,
  id: 'reconciliationType',
}
const occasionPrideType: EventDetailsType = { ...occasionAfternoonTeaType, id: 'prideType' }
const occasionChristmasInJulyType = { ...occasionLunarNewyearType, id: 'christmasInJulyType' }

export const occasions = (code: string): OccasionFieldsAndEventDetails => {
  const result: OccasionFieldsAndEventDetails = {
    skip: false,
    fields: [],
    eventDetails: [],
  }
  match(code)
    .with('BREAKFAST', () => {
      result.fields.push(occasionBreakfastType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('MORNING_TEA', () => {
      result.fields.push(occasionMorningTeaType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('LUNCH', () => {
      result.fields.push(occasionLunchType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('AFTERNOON_TEA', () => {
      result.fields.push(occasionAfternoonTeaType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('DINNER', () => {
      result.fields.push(occasionDinnerType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('SWEET_TREATS', () => {
      result.fields.push(occasionSweetTreatsType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('LUNAR_NEW_YEAR_EF', () => {
      result.fields.push(occasionLunarNewyearType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('INTERNATIONAL_WOMENS_DAY', () => {
      result.fields.push(occasionInternationalWomensDayType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('MARDI_GRAS', () => {
      result.skip = true
      result.fields.push(occasionMardiGrasType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('HARMONY_DAY', () => {
      result.skip = true
      result.fields.push(occasionHarmonyType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('EASTER', () => {
      result.skip = true
      result.fields.push(occasionEasterType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('AUSTRALIAS_BIGGEST_MORNING_TEA', () => {
      result.skip = true
      result.fields.push(occasionAustraliasBiggestMorningTeaType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('RECONCILIATION', () => {
      result.skip = true
      result.fields.push(occasionReconciliationType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('PRIDE', () => {
      result.skip = true
      result.fields.push(occasionPrideType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('CHRISTMAS_IN_JULY', () => {
      result.skip = true
      result.fields.push(occasionChristmasInJulyType)
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('WEAR_IT_PURPLE_DAY', () => {
      result.skip = true
      result.fields.push({ ...occasionAfternoonTeaType, id: 'wearItPurpleType' })
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('RUOK_DAY', () => {
      result.skip = true
      result.fields.push({ ...occasionAfternoonTeaType, id: 'ruokDayType' })
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('OKTOBERFEST', () => {
      result.fields.push({ ...occasionLunarNewyearType, id: 'octoberfestType' })
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('DIWALI', () => {
      result.skip = true
      result.fields.push({ ...occasionLunarNewyearType, id: 'diwaliType' })
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('HALLOWEEN', () => {
      result.skip = true
      result.fields.push({ ...occasionAfternoonTeaType, id: 'halloweenType' })
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('MELBOURNE_CUP', () => {
      result.skip = true
      result.fields.push({ ...occasionLunarNewyearType, id: 'melbourneCupType' })
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('CHRISTMAS', () => {
      result.skip = true
      result.fields.push({ ...occasionLunarNewyearType, id: 'christmasType' })
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('EARLY_BIRD_CHRISTMAS', () => {
      result.skip = true
      result.fields.push({ ...occasionLunarNewyearType, id: 'earlyBirdChristmasType' })
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('CORPORATE_FUNCTION_EVENT', () => {
      result.fields.push(
        occasionRequirements,
        occasionFoodServiceTime,
        occasionStaffServiceTime,
        occasionEventStyle,
        occasionServiceStyle,
        occasionOnsiteFacilities,
      )
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('EVENT_OTHER_SIMPLE', () => {
      result.fields.push(occasionEventOtherSimple)
      result.eventDetails.push(commonEventDetailsServingType)
    })

  return result
}
